var map = {
	"./ARS.png": "4fb8",
	"./BRL.png": "2f52",
	"./CLP.png": "c3ac",
	"./COP.png": "8f78",
	"./CRC.png": "307e",
	"./DOP.png": "5be5",
	"./EUR.png": "bbf7",
	"./GBP.png": "6475",
	"./MXN.png": "54e5",
	"./PEN.png": "47bf",
	"./USD.png": "5393",
	"./UYU.png": "32bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df57";